<script lang="ts">
  let {
    back,
    inactive,
    allInformationIsUnchanged,
  }: {
    back: () => void;
    inactive: boolean;
    allInformationIsUnchanged: boolean;
  } = $props();
</script>

<p class="h-full">
  {#if allInformationIsUnchanged}
    We noticed that all the information has remained the same. Our team may
    reach out for further details.
  {:else}
    Thank you for the updated information!
  {/if}
</p>

<div class="floating-footer">
  <button type="button" class="btn btn-ghost" onclick={back}>Back</button>
  <button type="submit" class="btn btn-primary" disabled={inactive}>Done</button>
</div>
